<template>
  <aha-modal-group
    @hide="hide"
    :hideSecondary="true"
    size="share-to-edit"
  >
    <template #header>
      <aha-svg
        size="lg"
        v-if="isShowShareToEditList"
        name="arrow-tail"
        view-box="0 0 18 19"
        @click="handleClickBack()"
        class="align-middle mr-2 cursor-pointer flex-shrink-0"
      />
      <aha-icon-container
        v-if="!isShowShareToEditList"
        class="my-3 mr-2 font-bold truncate cursor-pointer"
        size="md"
        icon-class="bg-primary-90 text-base-0"
      >
        <aha-icon
          name="share-collab"
          width="14"
          height="14"
          viewBox="0 0 18 16"
        />
      </aha-icon-container>
      <span class="inline-block align-middle">{{ shareToEditModalTitle }}</span>
    </template>
    <template #main>
      <ShareToEdit
        v-if="!isShowShareToEditList"
        :presentation="presentation"
        @handleShowShareToEditList="showShareToEditModal()"
        @prepareDataForInviteTeamModal="prepareDataForInviteTeamModal"
      />

      <ShareToEditList :presentation="presentation" v-if="isShowShareToEditList" />
    </template>
  </aha-modal-group>
</template>

<script>
import EventBus from '@/eventBus'
import ShareToEdit from '@/components-v2/presentation-editor/collaboration/ShareToEdit.vue'
import ShareToEditList from './ShareToEditList.vue'

export default {
  components: {
    ShareToEdit,
    ShareToEditList,
  },
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isShowShareToEditList: false,
      isShowShareACopyList: false,
      toBeInvitedMembers: null,
    }
  },
  computed: {
    shareToEditModalTitle() {
      return this.$i18nPresenter.t('Invite to edit')
    },
  },
  mounted() {
    EventBus.$on('clearOtherPopups', () => {
      this.$emit('hide')
    })
  },
  destroyed() {
    EventBus.$off('clearOtherPopups')
  },
  methods: {
    hide() {
      this.$emit('hide', {
        toBeInvitedMembers: this.toBeInvitedMembers,
      })
    },
    handleClickBack() {
      this.isShowShareToEditList = false
      this.isShowShareACopyList = false
      this.shareToEditModalTitle = this.$i18nPresenter.t('Invite to edit')
    },
    showShareToEditModal() {
      this.shareToEditModalTitle = this.$i18nPresenter.t('Invite team members')
      this.isShowShareToEditList = true
    },
    showSendACopyDialog() {
      this.shareToEditModalTitle = this.$i18nPresenter.t('Send a copy to team members')
      this.isShowShareACopyList = true
    },
    prepareDataForInviteTeamModal({ toBeInvitedMembers }) {
      this.toBeInvitedMembers = toBeInvitedMembers
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-modal ::v-deep .aha-modal__content-wrp {
  @apply justify-center;
}
</style>
